import { Input, Output, EventEmitter, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'analyse-pager',
    templateUrl: './pager.component.html',
})
export class AnalysePagerComponent implements OnInit {
    @Input() section;
    @Input() sections;

    @Output() navigate = new EventEmitter<Object>();

    constructor() { }

    ngOnInit() {
    }

    emit(commands: string[], force: boolean = false) {
        this.navigate.emit({
            commands,
            force
        });
    }

}



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/analyse/pager.component.ts